
const Footer=()=>(
    
    <div>
   <button onClick={ ()=>{
            for(i=0;i<100;i++){
              console.log("l ")
            }}}>here</button> <h2>footer</h2>
</div>
)
export default Footer;



//onclick={ ()=>{  for(i=0;i<100;i++){console.log("l ")  }}}>here</button>